import { render, staticRenderFns } from "./relationship-list.vue?vue&type=template&id=53ecf335"
import script from "./relationship-list.vue?vue&type=script&lang=js"
export * from "./relationship-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ecf335')) {
      api.createRecord('53ecf335', component.options)
    } else {
      api.reload('53ecf335', component.options)
    }
    module.hot.accept("./relationship-list.vue?vue&type=template&id=53ecf335", function () {
      api.rerender('53ecf335', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/info-management/relationship-list.vue"
export default component.exports